import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';

const CTASection = () => {
  const navigate = useNavigate();
  const { openAuthModal } = useAuth();

  return (
    <section 
      className="py-24 md:py-30 relative" 
      data-testid="cta-section"
    >
      {/* Desktop gradient */}
      <div 
        className="absolute inset-0 hidden md:block"
        style={{ background: 'linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(15, 23, 42) 60%, rgb(var(--primary)) 100%)' }}
      />
      {/* Mobile gradient - 25% dark blue then gradient to pink */}
      <div 
        className="absolute inset-0 md:hidden"
        style={{ background: 'linear-gradient(135deg, rgb(15, 23, 42) 0%, rgb(15, 23, 42) 25%, rgb(var(--primary)) 100%)' }}
      />
      <div className="container mx-auto px-6 md:px-12 lg:px-20 relative z-10">
        <motion.div 
          className="max-w-4xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-[1.65rem] sm:text-4xl lg:text-5xl font-heading font-medium text-white mb-12 tracking-tight">
            Ready to get into real estate?
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="bg-primary hover:bg-primary-hover text-white rounded-full px-10 py-7 text-lg font-medium transition-all duration-300 hover:scale-[1.02] hover:shadow-lg hover:shadow-primary/25"
              onClick={() => navigate('/projects')}
              data-testid="cta-explore-btn"
            >
              Explore projects
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="rounded-full px-10 py-7 text-lg font-medium border-white/20 text-white hover:bg-white/5"
              onClick={() => openAuthModal('register')}
            >
              Create your account
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
